"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addToBrushHistory = void 0;
function zoomHistoryManager(zoomHistory, nucleus, baseZoom) {
    if (!zoomHistory[nucleus] && !Array.isArray(zoomHistory[nucleus])) {
        zoomHistory[nucleus] = [];
    }
    const push = preparePush(zoomHistory[nucleus]);
    const pop = preparePop(zoomHistory[nucleus], baseZoom);
    const getLast = prepareGetLast(zoomHistory[nucleus]);
    const clear = () => (zoomHistory[nucleus] = []);
    return { historyStack: zoomHistory[nucleus], push, pop, getLast, clear };
}
exports.default = zoomHistoryManager;
function preparePush(historyStack) {
    return (val) => {
        historyStack.push(val);
    };
}
function preparePop(historyStack, baseZoom) {
    return () => {
        const val = historyStack.pop();
        if (val && historyStack.length === 0) {
            return baseZoom || null;
        }
        return val ? historyStack.at(-1) : null;
    };
}
function prepareGetLast(historyStack) {
    return () => {
        if (historyStack.length === 0)
            return null;
        return historyStack.at(-1);
    };
}
function addToBrushHistory(draft, options) {
    const { displayerMode } = draft;
    const { trackID, xDomain, yDomain } = options;
    const brushHistory = zoomHistoryManager(
    // eslint-disable-next-line unicorn/consistent-destructuring
    draft.zoom.history, 
    // eslint-disable-next-line unicorn/consistent-destructuring
    draft.view.spectra.activeTab);
    if (displayerMode === '2D') {
        switch (trackID) {
            case 'CENTER_2D':
                draft.xDomain = xDomain;
                draft.yDomain = yDomain;
                break;
            case 'TOP_1D':
                draft.xDomain = xDomain;
                break;
            case 'LEFT_1D':
                draft.yDomain = yDomain;
                break;
            default:
                break;
        }
        if (brushHistory) {
            brushHistory.push({ xDomain, yDomain });
        }
    }
    else {
        draft.xDomain = xDomain;
        if (brushHistory) {
            brushHistory.push({ xDomain, yDomain });
        }
    }
}
exports.addToBrushHistory = addToBrushHistory;
